import React from 'react';
import { useSelector} from 'react-redux';
import { Divider} from 'rsuite';
import NuInsStepper from '../elements/NuInsStepper';
import {steppLabels} from './common/types';
import {BackIcon} from '../svg/iconsSvg';
import CardPayment from './elements/CardPayment';

const PaymentWithCard = ({onBack, onForward, style}) => {

    const { revisedOffer } = useSelector(state => state.insOffers);

    const { installments, insuranceId, installmentsLEVA } = revisedOffer || {}; 
  
    let payAmount = installments ? Number.parseFloat(installmentsLEVA[0]).toFixed(2) : null;
    payAmount = Number.isNaN(parseInt(payAmount)) ? null : payAmount;

    let payAmountEUR = installments ? Number.parseFloat(installments[0]).toFixed(2) : null;
    payAmountEUR = Number.isNaN(parseInt(payAmountEUR)) ? null : payAmountEUR;

    const goBack = () => {
        onBack(14)
    }

    const goForward = () => {
        onForward(16);
    }

    return (
        <div className="steps_container" style={style}>
            <div className="head" style={{paddingTop: '0', marginBottom: '-18px'}}>
                <div className="head-icon" style={{margin: '0 -8px 0 4px'}} onClick={goBack}><BackIcon size={32}/></div>
                <NuInsStepper activeStep={4} steps={4} labels={steppLabels}/>              
            </div>
            <Divider style={{marginBottom: 0 , backgroundColor: '#6bdfa7', height: '.5px'}}/>

            <CardPayment insuranceId={insuranceId} cashflowId={1} payAmountEUR={payAmountEUR} payAmount={payAmount} onForward={goForward} />
        </div>
    );
}

export default PaymentWithCard;